import { UserRoles } from '../common/enums/enums';

export const hasDealerShipEmployeeRole = userRoles =>
  userRoles.some(u => u === UserRoles.DEALERSHIP_EMPLOYEE);

export const hasDealerShipManagerRole = userRoles =>
  userRoles.some(u => u === UserRoles.DEALERSHIP_MANAGER);

export const hasDealerShipBillingRole = userRoles =>
  userRoles.some(u => u === UserRoles.DEALERSHIP_BILLING);

export const hasDealerShipAdminRole = userRoles =>
  userRoles.some(u => u === UserRoles.DEALERSHIP_ADMIN);

export const companiesFilter = companies =>
  companies
    ?.filter(c => c.parentCompanyId)
    .filter(c => c.hasContracts)
    .sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });

export const currentUserDataFilter = (companyId, data) =>
  data?.filter(d => d.companyId === companyId);
